import React, { useMemo } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { LegacyHtml as Html } from 'src/app/shared/components/html';
import { useRichMediaTransformers } from 'src/app/shared/hooks/richMedia';

import { useDescriptionTracking } from '../../../../hooks/tracking/description';

export const DescriptionContent: React.FC = () => {
	const { trackClickLink } = useDescriptionTracking();
	const isSunriseTheme = useIsSunriseTheme();

	const {
		data: {
			petition: { description },
		},
	} = usePetitionDetailsPageData();

	const { decodeRichMediaTransformer } = useRichMediaTransformers();
	const htmlTransformers = useMemo(() => [decodeRichMediaTransformer], [decodeRichMediaTransformer]);

	return (
		<Box data-qa="description-content" data-testid="description-html-content">
			<Html
				size="default"
				breakWord
				html={description}
				sx={{
					...(isSunriseTheme && {
						fontFamily: 'serif',
						lineHeight: '28px',
					}),
					// Note: this nested iframe style is for embedded videos.
					iframe: {
						width: '100%',
						height: 'auto',
						aspectRatio: '16/9',
						lineHeight: '28px',
						fontWeight: '400',
					},
				}}
				transformers={htmlTransformers}
				onClickLink={trackClickLink}
			/>
		</Box>
	);
};
